export default __webpack_public_path__ + "static/open_house_may_2019_1-aa2bad13453e98abadd9e9a483d01807.jpg";